import { Component, OnInit, Input, ElementRef, OnChanges, OnDestroy, HostListener } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { Subscription } from 'rxjs';
import { RolesService } from 'src/app/services/roles-service/roles.service';

@Component({
  selector: 'app-roles-role-info-card',
  templateUrl: './roles-role-info-card.component.html',
  styleUrls: ['./roles-role-info-card.component.scss']
})
export class RolesRoleInfoCardComponent implements OnInit, OnChanges, OnDestroy {

  @Input() roleInfo;
  editingLocked: boolean;
  updateRoleInfoSubscription: Subscription;
  basicDataForm = new FormGroup({
    name: new FormControl({ value: '', disabled: true }, Validators.required)
  });

  constructor(private userStorageService: UserStorageService,
              private rolesService: RolesService,
              private snackBarService: SnackBarService,
              private eRef: ElementRef) { }

  ngOnInit() {
    this.editingLocked = true;
  }

  ngOnChanges() {
    if (this.roleInfo) {
      this.resetForm();
      this.lockEdition();
    }
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (this.eRef.nativeElement.contains(event.target)) {

    } else {
      if (event.path[0].className !== 'mat-option-text') {
        if (this.roleInfo && !this.editingLocked) {
          this.resetForm();
          this.lockEdition();
          this.editingLocked = true;
        }
      }
    }
  }

  public submitForm() {
      this.updateRoleInfoSubscription = this.rolesService.updateRoleInfo(this.roleInfo.RoleInternalId, this.userStorageService.getCompanyData().CompanyCode, this.basicDataForm.get('name').value).subscribe(
        (res) => {
          this.snackBarService.open('roles-page.snackbar messages.update role success', 'success');
          this.lockEdition();
          this.rolesService.refreshRole();
        },
        (error) => {
          this.snackBarService.open(error['error']['message'], 'error');
        }
      );
  }

  public toggleEdition() {
    if (this.editingLocked) {
      this.unlockEdition();
    } else {
      const validation = this.validateForm();
      if (validation === true) {
        this.submitForm();
      } else {
        this.snackBarService.open(validation, 'error');
      }
    }
  }

  private validateForm() {
    if (!this.basicDataForm.get('name').valid) {
      return 'roles-page.snackbar messages.name required error';
    } else {
      return true;
    }
  }

  public resetForm() {
    this.basicDataForm.patchValue({
      name: this.roleInfo.Rolename
    });
  }

  private unlockEdition() {
    this.basicDataForm.get('name').enable();
    this.editingLocked = false;
  }

  private lockEdition() {
    this.basicDataForm.get('name').disable();
    this.editingLocked = true;
  }

  ngOnDestroy() {
    if (this.updateRoleInfoSubscription) { this.updateRoleInfoSubscription.unsubscribe(); }
  }
}
